import { secondaryPackagingRequest } from '@/request'
interface funResult {
	code?: number;
	data?: any;
	message?: any;
}
//获取用户列表(分页)
export const userList = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/list',
    params,
    isLoading: false,
    needToken: true,
})
//获取个人信息
export const personalInfo = (): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/personalInfo',
    isLoading: false,
    needToken: true
})
//根据用户账号模糊查询
export const userQuery = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/query',
    params,
    isLoading: false,
    needToken: true
})
//根据用户账号查询(用户组查询)
export const userForGroup = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/selectForGroup',
    params,
    isLoading: false,
    needToken: true
})
//新增用户
export const userSave = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/addUser',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: true,
    needToken: true,
    loadingText: '注册中...'
})
//注册
export const userRegister = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/register',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: true,
    needToken: false,
    loadingText: '注册中...'
})
//修改用户
export const userUpdate = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/update',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//删除用户
export const userDelete = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/delete',
    method: 'POST',
    params,
    isLoading: false,
    needToken: true
})
//修改个人资料（用户头像）
export const updateAvatar = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/updateAvatar',
    method: 'POST',
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    data,
    isLoading: false,
    needToken: true
})
//修改密码
export const updatePassword = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/updateMyPwd',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//修改用户角色
export const updateUserRole = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/updateUserRole',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//修改角色定位信息
export const updateUserPosition = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/position',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//修改密码
export const updateUserPassword = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/updatePassword',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//绑定手机
export const bindPhone = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/bindPhone',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//绑定邮箱
export const bindEmail = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/bindEmail',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//启用
export const userEnable = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/enable',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    params,
    isLoading: false,
    needToken: true
})
//禁用
export const userDisable = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/disable',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    params,
    isLoading: false,
    needToken: true
})